<div class="customize-object-config">
  <!-- vị trí của đối tượng -->
  <app-position-out-config [elementChoosing]="objectChoosing" [device]="device"
    [id_parent_choose]="objectChoosing.id_block? objectChoosing.id_block: objectChoosing.id_object">
  </app-position-out-config>
  <!-- kích thước -->
  <app-width-height-config [device]="device" [elementChoosing]="objectChoosing" [width]="class['customize-object']['width']"
    [height]="class['customize-object']['height']" (changeWidthHeight)="changeWidthHeight($event)">
  </app-width-height-config>

  <!-- embed -->
  <div class="tab-header">
    <button (click)="activeTab = 'html'" [class.active]="activeTab === 'html'">HTML</button>
    <button (click)="activeTab = 'css'" [class.active]="activeTab === 'css'">CSS</button>
    <button (click)="activeTab = 'js'" [class.active]="activeTab === 'js'">JS</button>
    <button class="fullscreen-btn" (click)="toggleFullscreen()">⛶</button>
  </div>

  <!-- Textarea cho từng tab -->
  <div class="tab-content">
    <textarea *ngIf="activeTab === 'html'" placeholder="Nhập mã HTML của bạn ở đây..."
      [(ngModel)]="config.code_value.html" (blur)="generateCode()"></textarea>

    <textarea *ngIf="activeTab === 'css'" placeholder="Nhập mã CSS của bạn ở đây..."
      [(ngModel)]="config.code_value.css" (blur)="generateCode()"></textarea>

    <textarea *ngIf="activeTab === 'js'" placeholder="Nhập mã JavaScript của bạn ở đây..."
      [(ngModel)]="config.code_value.js" (blur)="generateCode()"></textarea>
  </div>
</div>